import {getLastDomainFilter, setLastDomainFilter} from 'util/ProgressUtil'
import HeroDropdown from 'views/components/heroButton/heroDropdown/HeroDropdown'

function heroDropdownCallback(heroDropdown, groupModel, value, callback) {
    if (value === null) {
        heroDropdown.setLabel(`${window.i18n.gettext('Progress')}: ${window.i18n.gettext('All tasks')}`)
        setLastDomainFilter(groupModel, null)
        callback()
        return
    }
    heroDropdown.setLabel(value.name)
    setLastDomainFilter(groupModel, value.id)
    callback(value.id)
}

export function createContentDomainFilterHeroDropdown(model, callback) {
    const contentDomain = model.getContentDomain()
    const groupModel = model.getGroupModel()
    if (!contentDomain) {
        return
    }
    const heroDropdown = new HeroDropdown({
        firstLine: `${window.i18n.gettext('Progress')}: ${window.i18n.gettext('All tasks')}`,
        icon: 'arrow-drop-down-circle',
        dropdownItems: contentDomain.get('items').reduce((m, item) => {
            m.push({
                label: item.name,
                callback: () => heroDropdownCallback(heroDropdown, groupModel, item, callback),
            })
            return m
        },
        [
            {
                label: window.i18n.gettext('All tasks'),
                callback: () => heroDropdownCallback(heroDropdown, groupModel, null, callback),
            }
        ])
    })
    Backbone.View.header.addButton(heroDropdown)
    heroDropdownCallback(heroDropdown, groupModel, getLastDomainFilter(groupModel), callback)
}
